import { FormattedMessage } from "react-intl";
import StatisticsPercentOverview from "../../common/StatisticsPercentOverview";

const arrowSVG = (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.06012 3.49414C5.06012 3.25252 5.256 3.05664 5.49762 3.05664L10.5051 3.05664C10.6212 3.05664 10.7324 3.10273 10.8145 3.18478C10.8965 3.26683 10.9426 3.37811 10.9426 3.49414L10.9426 8.50164C10.9426 8.74326 10.7467 8.93913 10.5051 8.93914C10.2635 8.93914 10.0676 8.74326 10.0676 8.50164L10.0676 3.93164L5.49762 3.93164C5.256 3.93164 5.06012 3.73577 5.06012 3.49414Z"
      fill="#479821"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.18387 10.8155C3.01302 10.6446 3.01302 10.3676 3.18387 10.1967L10.1259 3.25472C10.2967 3.08387 10.5738 3.08387 10.7446 3.25472C10.9155 3.42558 10.9155 3.70259 10.7446 3.87344L3.80259 10.8155C3.63173 10.9863 3.35473 10.9863 3.18387 10.8155Z"
      fill="#479821"
    />
  </svg>
);
const TotalProducts = ({
  title,
  description,
  icon,
  secondTitle,
  minHeight,
  paddingX = "16px",
  paddingY = "16px",
  chartComponent,
  sales,
  percent,
}: any) => {
  return (
    <div
      className={`flex flex-col md:flex-row justify-between my-2 rounded-lg w-full  `}
    >
      <div className=" text-center md:text-start flex flex-col gap-3">
        <p className="text-[#75757E] ">{icon}</p>
        <p className=" text-[#75757E]">{secondTitle}</p>
        <h2 className="text-[20px]  font-medium flex items-center gap-2">
          <span className="">{sales}</span>
          {title}
        </h2>
        <StatisticsPercentOverview percent={percent} />
      </div>
    </div>
  );
};

export default TotalProducts;
